let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iBaPP")).then(() => parcelRequire('eONcC'));